export default __webpack_public_path__ + "static/media/globe.0c1fbe97.svg";